import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Signup from "../pages/Signup";
import About from "../pages/About";
import Home from "../pages/Home";
import Search from "../pages/Search";
import View from "../pages/View";
import TermsOfService from "../pages/TermsOfService";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import NotFound from "../pages/NotFound";
import KeycloakCallback from "../pages/KeycloakCallback";
import { useAuth } from "../utils/AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

// landing
import Landing from "../pages/Landing";
import Login from "../pages/Login";

import Base from "../pages/Landing/components/Base";

const AppRoutes: React.FC = () => {
  const { setToken } = useAuth();

  return (
    <Routes>
      {/* Landing */}
      <Route path="/" element={<Base />}>
        <Route index element={<Landing />} />
        <Route path="/login" element={<Login setToken={setToken} />} />
        <Route path="/signup" element={<Signup setToken={setToken} />} />
      </Route>

      <Route element={<PublicRoute />}>
        <Route
          path="/auth/keycloak"
          element={<KeycloakCallback setToken={setToken} />}
        />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<Home />} />
        <Route path="/search" element={<Search />} />
        <Route path="/view/:id" element={<View />} />
      </Route>

      <Route path="/about" element={<About />} />
      <Route path="/legal/terms-of-service" element={<TermsOfService />} />
      <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
      {/* <Route path="/" element={<AuthRedirector />} /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

// const AuthRedirector: React.FC = () => {
//   const { isAuthenticated, isLoading } = useAuth();

//   if (isLoading) return <div>Loading...</div>;
//   return isAuthenticated ? (
//     <Navigate to="/home" replace />
//   ) : (
//     <Navigate to="/login" replace />
//   );
// };

export default AppRoutes;
